'use client'

;!function(){try{var e="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { clsx } from 'clsx'

import { Dropdown, DropdownButton, DropdownItem, DropdownMenu } from '@/components/ui/dropdown'
import { getPagePath, type Locale, type PageKey } from '@/i18n/routing'
import { ChevronRightIcon, GlobeAltIcon } from '@heroicons/react/24/outline'

export function FooterLanguageSwitcher({
  locale,
  pageKey,
  labels,
  hrefByLocale,
}: {
  locale: Locale
  pageKey: PageKey
  labels: Record<Locale, string>
  hrefByLocale?: Partial<Record<Locale, string>>
}) {
  return (
    <Dropdown>
      <DropdownButton
        as="button"
        className="group inline-flex items-center gap-2 text-sm/7 font-medium text-mist-600 transition hover:text-mist-950 dark:text-mist-400 dark:hover:text-white"
      data-sentry-element="DropdownButton" data-sentry-source-file="footer-language-switcher.tsx">
        <GlobeAltIcon className="h-4 w-4" data-sentry-element="GlobeAltIcon" data-sentry-source-file="footer-language-switcher.tsx" />
        <span>{labels[locale]}</span>
        <ChevronRightIcon className="h-2 w-2 rotate-90 text-mist-500 transition-transform duration-200 group-data-[open]:rotate-[270deg] dark:text-mist-300" data-sentry-element="ChevronRightIcon" data-sentry-source-file="footer-language-switcher.tsx" />
      </DropdownButton>
      <DropdownMenu anchor="top start" className="min-w-[12rem] py-3" data-sentry-element="DropdownMenu" data-sentry-source-file="footer-language-switcher.tsx">
        {Object.entries(labels).map(([key, label]) => {
          const nextLocale = key as Locale
          const href = hrefByLocale?.[nextLocale] ?? getPagePath(nextLocale, pageKey)
          const isActive = nextLocale === locale

          return (
            <DropdownItem
              key={nextLocale}
              href={href}
              className={clsx('mb-1 last:mb-0', isActive && 'bg-mist-950/10 dark:bg-white/10')}
            >
              {label}
            </DropdownItem>
          )
        })}
      </DropdownMenu>
    </Dropdown>
  )
}
